/* ++++++++++ --------------- DRAGGABLE SORTABLE LIST STYLE : STYLES --------------- ++++++++++ */

import {pxToEm} from "@insticator/insticator-ui";

export default theme => ({
    draggableList:{
        gap: pxToEm(8),
        padding: pxToEm(16),
        height: pxToEm(338),
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
            width: pxToEm(5)
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: pxToEm(9999),
            background: 'rgba(206, 212, 228, 0.85)',
        },
        '& > .sortableitem': {
            width: '100%',
            border: '0.0625em solid #E7ECF7',
            height: pxToEm(48),
            margin: pxToEm(8),
            display: 'inline-flex',
            padding: pxToEm(12),
            alignItems: 'center',
            borderRadius: pxToEm(12),
            backgroundColor: 'white',
            left: 'auto !important',
            top: 'auto !important',
            '& > .singleitem':{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                gap: pxToEm(8),
                '& > .drag-icon':{
                    '& > svg':{
                        height: pxToEm(16),
                        width: pxToEm(16),
                    }
                },
                '& > .removeitem':{
                    marginLeft: 'auto',
                    '& > button' :{
                        border: 'none',
                        cursor: 'pointer',
                        backgroundColor: 'transparent',
                        '& > span': {
                            '& > .svg': {
                                marginTop: '0.4em',
                            }
                        }
                    }
                }
            },
        }
    },
    'scrollableHeight': {
        height: pxToEm(600),
    }

})